import { doubleEncode, makeDeleteRequest } from "../../utils";

type DeleteSessiion_sRecordingsOptions = {
	sessionId: string;
	action: "trash" | "delete";
};
export const deleteSessiion_sRecordings = async (
	token: string,
	options: DeleteSessiion_sRecordingsOptions,
) => {
	await makeDeleteRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"recordings",
		],
		options,
	});
};

export const curriedDeleteSessiion_sRecordings = (token: string) => (
	options: DeleteSessiion_sRecordingsOptions,
) => deleteSessiion_sRecordings(token, options);
